import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import ChipEdit from 'ChipEdit';
import transform from 'chipDataTransform';
import Ad from '@ifeng/ui_pc_ad';
import Nav from '../../components/topNav';
import HtmlRegion from '../../components/htmlRegion';
import HeaderNav from '../../components/header/';
import Logo from './logo';
import Content from './content';
import Aside from './aside';
import Footer from './bottomFooter';
import ToTop from '../../components/toTop';
import AdRegion from './adRegion';

class Layout extends PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;
        const logoData = {
            search: content.search,
            channel: content.channel,
            noAd: content.noAd,
            guanmingAd: content.guanmingAd,
        };
        const contentData = {
            channel: content.channel,
            newsstream: content.newsstream,
            isEnd: content.isEnd,
            columnId: content.columnId,
            mainData: content.mainData,
            commonIdArray: content.commonIdArray,
            newsStream1Ad: content.newsStream1Ad,
            newsStream2Ad: content.newsStream2Ad,
            noAd: content.noAd,
            newsStream: content.newsStream, // 覆盖配置
            allColumnData: content.allColumnData,
            articleAd: content.articleAd,
        };
        const asideData = {
            asideData: content.autoAsideData,
            noAd: content.noAd,
            asideAd: content.asideAd,
            columnId: content.columnId,
            hotArticleRank: content.hotArticleRank,
        };
        const footerData = {
            bottomAd: content.bottomAd,
            footer: content.footer,
        };
        const adData = {
            float1Ad: content.float1Ad,
            float2Ad: content.float2Ad,
            coupletAd: content.coupletAd,
            rightBottomAd: content.rightBottomAd,
            popunderAd: content.popunderAd,
            triggerLeftAd: content.triggerLeftAd,
        };
        const { nav } = content;

        return (
            <Fragment>
                <ChipEdit transform={transform} />
                {/* 顶部导航 */}
                <HeaderNav limit={18} content={nav} />
                {/* 顶部广告 */}
                {content.noAd ? null : <Ad styleName={styles.top_ad} content={content.headAd} />}
                {/* logo */}
                <Logo content={logoData} />
                {/* 导航栏 */}
                <Chip id={content.topNavId} type="struct" title="导航" groupName="导航栏 " content={content.topNav}>
                    <Nav />
                </Chip>
                {/* main */}
                <div className={`${styles.main} clearfix`}>
                    {/* 左侧新闻 */}
                    <Content content={contentData} />
                    {/* 右侧aside */}
                    <Aside content={asideData} />
                </div>
                {content.passAd ? <Ad styleName={styles.passAd} content={content.passAd} /> : null}
                {/* 底部合作链接 */}
                <Chip
                    id={content.footerId}
                    type="static"
                    title="底部合作链接"
                    groupName="底部"
                    content={content.cooperation}>
                    <HtmlRegion />
                </Chip>

                {/* 底部广告位 */}
                {content.noAd ? null : <Ad styleName={styles.footer_ad} content={content.footerAd} />}
                {/* 底部 */}
                <Footer content={footerData} />
                {/* 返回顶部 */}
                <ToTop />
                {/* 广告位 */}
                {content.noAd ? null : <AdRegion content={adData} />}
            </Fragment>
        );
    }
}

export { Layout };
export default Layout;
